import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.DOM.form = this.DOM.view.querySelector('form');
    this.events();
  }

  events() {
    for (let trigger of this.$('trigger')) {
      trigger.addEventListener('click', () => {
        this.$('input')[0].value = trigger.dataset.value;
        this.DOM.form.submit();
      });
    }
  }
}
